module.exports = __webpack_public_path__ + "img/181-84b042.png";